import { gql } from '@apollo/client';

const ADD_LISTING = gql`
  mutation ($input: AddListingInput!) {
    addListing(input: $input) {
      id
      title
    }
  }
`;

const DELETE_LISTING = gql`
  mutation ($input: DeleteListingInput!) {
    deleteListing(input: $input)
  }
`;

const GET_LISTING = gql`
  query ($listingId: String!) {
    listing(listingId: $listingId) {
      id
      introduction
      title
      price
      centroid {
        lat
        lng
      }
      bounds {
        lat
        lng
      }
      area
      sellingOption
      pricingOption
      landParcels {
        id
        polygon {
          points {
            lat
            lng
          }
        }
      }
      images {
        items {
          id
          fileName
        }
        hasNext
        page
        limit
      }
    }
  }
`;

const GET_LISTINGS = gql`
  query (
    $createdBy: String
    $centerSphere: CenterSphereInput
    $excludes: [String!]
  ) {
    listings(
      createdBy: $createdBy
      centerSphere: $centerSphere
      excludes: $excludes
    ) {
      items {
        id
        title
        introduction
        price
        pricingOption
        images {
          items {
            id
            fileName
          }
        }
        bounds {
          lat
          lng
        }
        centroid {
          lat
          lng
        }
        createdByUser {
          firstName
          lastName
        }
        createdAt
      }
      page
      limit
      hasNext
    }
  }
`;

export { ADD_LISTING, GET_LISTINGS, GET_LISTING, DELETE_LISTING };
